import { useMutation } from "@tanstack/react-query";
import client from "../../utils/Client";

// Posts to: [HttpPost("profileUser")]
// Keep payload property names in PascalCase to match RegisterWithoutADDTO
export const useSignUp = () => {
  const signUp = (payload) => client.post("auth/profileUser", payload);
  return useMutation((payload) => signUp(payload));
};
